/** Segment colors per engagement metric, shared by every statistics chart so a metric keeps its color. */
export const METRIC_COLORS = {
  views: 'var(--metric-views)',
  interactions: 'var(--metric-interactions)',
  checkIns: 'var(--metric-checkins)',
  follows: 'var(--metric-checkins)',
  likes: 'var(--metric-likes)',
  impressions: 'var(--metric-impressions)',
} as const
